export default __webpack_public_path__ + "static/media/down-arrow.339ff8ab.svg";